import { DelegateOf, TypeOfPersonType } from "@/shared/types/user";
import {
  IDENTIFIER_TYPE_AK,
  IDENTIFIER_TYPE_JAR,
  IDENTIFIER_TYPE_VAT,
} from "@/shared/constants/businessEntity";

export const getPersonDisplayName = (person: DelegateOf): string => {
  if (person.type === TypeOfPersonType.NATURAL) {
    return `${person.firstName} ${person.lastName}`;
  }
  return person.name;
};

export const getPreferredIdentifier = (person: DelegateOf) => {
  return (
    person.traderIdentifiers?.find(
      id => id.typeOfIdentifier === IDENTIFIER_TYPE_JAR
    ) ||
    person.traderIdentifiers?.find(
      id => id.typeOfIdentifier === IDENTIFIER_TYPE_AK
    ) ||
    person.traderIdentifiers?.find(
      id => id.typeOfIdentifier === IDENTIFIER_TYPE_VAT
    )
  );
};

export const getTypeOfIdentifier = (person: DelegateOf) => {
  return getPreferredIdentifier(person)?.typeOfIdentifier || "-";
};

export const getTIN = (person: DelegateOf) => {
  return getPreferredIdentifier(person)?.tin || "-";
};
